import React, { useState, useEffect } from 'react';
import Plot from 'react-plotly.js';
import CryptoOverviewPage from './CryptoOverviewPage';
import './CryptoOverviewPage.css';

const Dashboard = ({ cryptoType }) => {
  const [lineChart, setLineChart] = useState(null);
  const [barChart, setBarChart] = useState(null);
  const [pieChart, setPieChart] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000';

  useEffect(() => {
    // Only fetch charts if no cryptoType is provided
    if (!cryptoType) {
      fetchCharts();
    }
  }, [cryptoType]);

  // If cryptoType is provided, show the crypto overview page instead of charts
  if (cryptoType) {
    return <CryptoOverviewPage cryptoType={cryptoType} />;
  }

  const fetchCharts = async () => {
    try {
      setLoading(true);
      
      // Fetch all charts in parallel
      const [lineResponse, barResponse, pieResponse] = await Promise.all([
        fetch(`${API_BASE_URL}/chart/line`),
        fetch(`${API_BASE_URL}/chart/bar`),
        fetch(`${API_BASE_URL}/chart/pie`)
      ]);

      if (!lineResponse.ok || !barResponse.ok || !pieResponse.ok) {
        throw new Error('Failed to fetch chart data');
      }

      const lineData = await lineResponse.json();
      const barData = await barResponse.json();
      const pieData = await pieResponse.json();

      setLineChart(JSON.parse(lineData.chart));
      setBarChart(JSON.parse(barData.chart));
      setPieChart(JSON.parse(pieData.chart));
      
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="dashboard-loading">
        <h2>Loading Dashboard...</h2>
        <p>Fetching data and generating charts...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="dashboard-error">
        <h2>Error Loading Dashboard</h2>
        <p>{error}</p>
        <button onClick={fetchCharts}>Retry</button>
      </div>
    );
  }

  return (
    <div className="dashboard">
      <header className="dashboard-header">
        <h1>Data Dashboard</h1>
        <button onClick={fetchCharts} className="refresh-btn">
          Refresh Data
        </button>
      </header>

      <div className="charts-container">
        <div className="chart-section">
          <h2>Line Chart</h2>
          {lineChart && (
            <Plot
              data={lineChart.data}
              layout={lineChart.layout}
              style={{ width: '100%', height: '400px' }}
            />
          )}
        </div>

        <div className="chart-section">
          <h2>Bar Chart</h2>
          {barChart && (
            <Plot
              data={barChart.data}
              layout={barChart.layout}
              style={{ width: '100%', height: '400px' }}
            />
          )}
        </div>

        <div className="chart-section">
          <h2>Pie Chart</h2>
          {pieChart && (
            <Plot
              data={pieChart.data}
              layout={pieChart.layout}
              style={{ width: '100%', height: '400px' }}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default Dashboard;

